module.exports = __webpack_public_path__ + "static/selfie-d7a0eee325962ea3f4e9366c4cc39f06.png";